/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	icon: {
		':before': {
			display: 'inline',
			padding: '0px',
			verticalAlign: 'middle',
			lineHeight: '1.42968'
		}
	}
});

export default styles;
